import { render, staticRenderFns } from "./DefaultParametersDisplay.vue?vue&type=template&id=12e8566a&scoped=true&"
import script from "./DefaultParametersDisplay.vue?vue&type=script&lang=js&"
export * from "./DefaultParametersDisplay.vue?vue&type=script&lang=js&"
import style0 from "./DefaultParametersDisplay.vue?vue&type=style&index=0&id=12e8566a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e8566a",
  null
  
)

export default component.exports